export const SEOPackageId = "CompetitiveIntelligenceSEO";
export const CIPackageId = "CompetitiveIntelligence";
export const SIPackageId = "PremiumSalesExtension";
export const ADsPackageId = "ADsCompetitiveIntelligenceSEOAEO";
